import { useQuery } from "@tanstack/react-query";
import { getItemStockUnit } from "src/services/ItemStockUnit.service";
import { ItemStockUnitParams } from "./interfaces";
import { reactQueryOptions } from "src/config/reactQuery.config";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { AccessResource, ActionType } from "src/types/accessControl";

export const useGetItemStockUnit = (params: ItemStockUnitParams) => {
  const isAllowedItemStockUnit = useGetAccessPermission({
    resource: AccessResource["Master Data - Item Stock Unit"],
    action: ActionType["Read"],
  });
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["item-stock-unit", params],
    queryFn: () => getItemStockUnit(params),
    enabled: isAllowedItemStockUnit,
  });
};
